import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import Landing from "./pages/Landing";
import BookingsDashboard from "./pages/BookingsDashboard";
import CheckoutPage, { CheckoutReturn } from "./pages/CheckoutPage";

function App() {
  return (
    <>
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<BookingsDashboard />} />
          <Route path="/pay/:ref" element={<CheckoutPage />} />
          <Route path="/pay/:ref/complete" element={<CheckoutReturn />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
